import BaseUtil from "../../../util/BaseUtil";
import UserTypeUtil from "../../../util/UserTypeUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const chartTypeMap = {
    pie: "环状图",
    bar: "柱状图",
};

const initState = {
    selectedUnitIds: null,
    selectedUserTypes: UserTypeUtil.getAllUserTypeCodes(),

    chartType: "pie", // 图表类型
    datePicker: {
        beginDate: null, // datepicker开始时间
        endDate: null, // datepicker结束时间
    },
    chartsLoading: true,
    chartsData: null, // 图表数据
    dimissionDetailVisible: false, // 详情
    clickedChart: null, // 选中的图表
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    // 筛选
    filterData: null,
    filterDisplay: null,
    // filterOriginObj: null,
    filterInitData: {
        groups: [],
        items: [],
        dicts: {},
    },

    itemFiltered: null, // 启用的字段
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    chartTypeMap,
};
export default viewModel;
